import Vue from 'vue'
import Vuex from 'vuex'

//  root utility
import actions from './store/root/actions.js'
import mutations from './store/root/mutations'
import getters from './store/root/getters'

// vuex persist
import VuexPersist from 'vuex-persist';
// end of vuex persist


Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: window.localStorage,
  reducer: state => ({
    user: state.user,
  })
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

export default new Vuex.Store({
  state: {
    appName: 'eWak',
    user: {}
  },
  mutations,
  actions,
  getters,
  plugins: [vuexLocalStorage.plugin]
})
